import { Center, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { CalendarIcon } from '@/imports/ui/chakra/feather';

export const EventListEmpty: React.FC<{
  title: string;
  description?: string;
}> = ({ title, description }) => {
  return (
    <Card p="4">
      <Center h={96} as={VStack} spacing="1">
        <CalendarIcon boxSize={5} color="gray.500" mb="2" />
        <Text fontWeight="semibold" color="gray.700">
          {title}
        </Text>
        {description && <Text color="gray.600">{description}</Text>}
      </Center>
    </Card>
  );
};
